import React from 'react';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import { Building, Store, Home, Building2, Warehouse } from 'lucide-react';

const BUILDING_TYPES = [
    { id: 'Residential Villa', label: 'Villa', icon: <Home size={16} /> },
    { id: 'Modern Duplex', label: 'Duplex', icon: <Building2 size={16} /> },
    { id: 'Apartment Complex', label: 'Apartments', icon: <Building size={16} /> },
    { id: 'Commercial Showroom', label: 'Showroom', icon: <Store size={16} /> },
    { id: 'Office Building', label: 'Office', icon: <Building size={16} /> }, // Reusing Building icon for now or find better
    { id: 'Industrial Warehouse', label: 'Warehouse', icon: <Warehouse size={16} /> },
];

const BuildingTypeSelector: React.FC = () => {
    const { projectType, setProjectType } = useArchitectureStore();

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2 text-stone-500 px-1">
                <Building size={14} />
                <span className="text-xs font-bold uppercase tracking-widest">Building Type</span>
            </div>

            <div className="grid grid-cols-3 gap-2">
                {BUILDING_TYPES.map(type => (
                    <button
                        key={type.id}
                        onClick={() => setProjectType(type.id)}
                        className={`flex flex-col items-center justify-center gap-1 p-2 rounded-lg border transition-all text-xs font-medium ${projectType === type.id
                            ? 'bg-stone-800 border-orange-500/50 text-white shadow-sm'
                            : 'bg-stone-900/40 border-stone-800 text-stone-500 hover:bg-stone-900 hover:text-stone-300'
                            }`}
                        title={type.id}
                    >
                        {type.icon}
                        <span className="truncate w-full text-center">{type.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default BuildingTypeSelector;
